import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./chat.css";
import chatLogo from "../../Assets/Images/ChatGPT-Icon-Logo.png";
import brokarChatLogo from "../../Assets/Images/chat.png";

import chatLoader from "../../Assets/Images/chat-loader.gif";
import defaultuser from "../../Assets/Images/default.png";
import { Button } from "react-bootstrap";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TourIcon from "@mui/icons-material/Tour";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import { ContainedButton } from "../../Common/Buttons";
import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ChatPopUp = ({ callParent }) => {
  const themeColor = localStorage.getItem("theme");
  const { btncolor, brokerBasicInfo } = useSelector((state) => state);
  const location = useLocation();

  const [isLinkAvailable, setIsLinkAvailable] = useState(false);
  const [youtubeLink, setYoutubeLink] = useState("");
  const [showText, setShowText] = useState(false);

  // Get the path and split it
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const pageName = pathSegments[pathSegments.length - 1];
  const [isChatPopUpOpen, setIsChatPopUpOpen] = useState(false);
  const [chatText, setChatText] = useState("");
  const [imageLink, setImageLink] = useState(defaultuser);
  const [chatList, setChatList] = useState([]);
  const [isMessageSending, setIsMessageSending] = useState(false);
  const profilePic = localStorage.getItem("profile_pic");
  const { userProfileImage } = useSelector((state) => state);
  const containerRef = useRef(null);
  const messageRefs = useRef([]);
  const inputRef = useRef(null);
  const [settingFeature, setSettingFeature] = useState({});
  const isValid = userProfileImage?.replace(
    "data:application/json;base64,",
    ""
  );

  // Effect to override CSS for light theme
  useEffect(() => {
    if (themeColor !== "dark") {
      messageRefs.current.forEach((ref, index) => {
        if (ref && chatList[index]?.messageSendByUser) {
          ref.style.setProperty("background", "#e8e8e8", "important");
          ref.style.setProperty("box-shadow", "2px 2px 2px #ccc", "important");
        }
      });
    }
  }, [chatList, themeColor]);

  // Effect to handle input focus styling in light theme
  useEffect(() => {
    const inputElement = inputRef.current;
    if (!inputElement) return;

    const handleFocus = () => {
      if (themeColor !== "dark") {
        inputElement.style.setProperty("background-color", "#fff", "important");
        inputElement.style.setProperty("color", "#000", "important");
      }
    };

    const handleBlur = () => {
      if (themeColor !== "dark") {
        inputElement.style.setProperty("background-color", "#fff", "important");
        inputElement.style.setProperty("color", "#000", "important");
      }
    };

    inputElement.addEventListener("focus", handleFocus);
    inputElement.addEventListener("blur", handleBlur);

    // Set initial style for light theme
    if (themeColor !== "dark") {
      inputElement.style.setProperty("background-color", "#fff", "important");
      inputElement.style.setProperty("color", "#000", "important");
    }

    return () => {
      inputElement.removeEventListener("focus", handleFocus);
      inputElement.removeEventListener("blur", handleBlur);
    };
  }, [themeColor, isChatPopUpOpen]);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const accessToken = localStorage.getItem("access_token");
    if (profilePic && userId && accessToken) {
      setImageLink(
        `${WEBSERVICE}user/${userId}/file/${profilePic}?access_token=${accessToken}`
      );
    }
    getBrokerExchangeFeatures();
  }, []);

  useEffect(() => {
    showYoutubeLink();
  }, [location.pathname]);

  const handleInitialMessageOfChatbox = () => {
    setChatText("");
    setChatList([
      {
        message: `Hi ${localStorage.getItem("user_name")}, how can I help you?`,
        messageSendByUser: false,
      },
    ]);
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [chatList]);

  const handleOpenChatPopUp = () => {
    handleInitialMessageOfChatbox();
    setIsChatPopUpOpen(!isChatPopUpOpen);
  };

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (chatText.trim() !== "") {
      const userMessage = { message: chatText, messageSendByUser: true };
      console.log("userMessage", userMessage);

      setChatList([...chatList, userMessage]);
      handleApiCallForChat(chatText);
    }
  };

  const handleApiCallForChat = async (message) => {
    setIsMessageSending(true);
    const payload = { message };

    try {
      const response = await axios.post(
        "https://accounts.paybito.com/api/user/chatgpt",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      console.log("chatResponse", response);
      const chatResponse = JSON.parse(response?.data?.body);

      if (chatResponse.statuscode !== 1) {
        showToast("error", chatResponse.message);
      } else {
        setChatList((prevChat) => [
          ...prevChat,
          { message: chatResponse.message, messageSendByUser: false },
        ]);
      }
    } catch (error) {
      console.error("CHATGPT ERROR ==> ", error);
      showToast(
        "error",
        error.response?.statusText === "Unknown Error"
          ? "Session timed out. Please log in again."
          : "Internal Server Error"
      );
    }
    setChatText("");
    setIsMessageSending(false);
  };

  // const handleApiCallForChat = async (message) => {
  //   setIsMessageSending(true);
  //   const payload = { question: message };

  //   try {
  //     const response = await axios.post(
  //       "https://whizzo-ai.paybito.com/api/ask",
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           authorization: `BEARER ${localStorage.getItem("access_token")}`,
  //         },
  //       }
  //     );

  //     console.log("chatResponse", response);
  //     const chatResponse = response?.data;

  //     if (!chatResponse.success) {
  //       showToast("error", chatResponse.answer);
  //     } else {
  //       setChatList((prevChat) => [
  //         ...prevChat,
  //         { message: chatResponse.answer, messageSendByUser: false },
  //       ]);
  //     }
  //   } catch (error) {
  //     console.error("CHATGPT ERROR ==> ", error);
  //     showToast(
  //       "error",
  //       error.response?.statusText === "Unknown Error"
  //         ? "Session timed out. Please log in again."
  //         : "Internal Server Error"
  //     );
  //   }
  //   setChatText("");
  //   setIsMessageSending(false);
  // };

  const showYoutubeLink = () => {
    const brokerId = localStorage.getItem("BROKERID");
    const token = localStorage.getItem("access_token");
    const url = `${WEBSERVICE}home/getAllExchangePageYoutubeLink?brokerId=${brokerId}`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${token}`,
        },
      })
      .then((response) => {
        let res = response.data.exchangePageYoutubeLinks;
        res = res.filter((x) => x.pageLink === location.pathname);
        res = res[0];

        console.log("route url", res);
        console.log("current url", location.pathname);

        if (
          res &&
          location.pathname === res.pageLink &&
          res.youtubeLink != null &&
          res.isActive === 1
        ) {
          setIsLinkAvailable(true);
          setYoutubeLink(res.youtubeLink);
        } else {
          setIsLinkAvailable(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching YouTube links:", error);
        setIsLinkAvailable(false);
      });

    // Fallback logic (if needed)
    /*
    const currentLink = location.pathname;
    setIsLinkAvailable(true);

    if (currentLink === '/basic') {
      setYoutubeLink('https://youtu.be/cBahq2EjOOY');
    } else if (currentLink === '/spot') {
      setYoutubeLink('https://youtu.be/U_on0Mc9Wxs');
    } else if (currentLink === '/dashboard') {
      setYoutubeLink('https://youtu.be/U_on0Mc9Wxs');
    } else if (currentLink === '/otc') {
      setYoutubeLink('https://youtu.be/S5acS3LUUlc');
    } else if (currentLink === '/p2p/dashboard') {
      setYoutubeLink('https://youtu.be/MSMNZ4YkiIA');
    } else if (currentLink === '/p2p/my-orders') {
      setYoutubeLink('https://youtu.be/MSMNZ4YkiIA');
    } else if (currentLink === '/p2p/my-profile') {
      setYoutubeLink('https://youtu.be/MSMNZ4YkiIA');
    } else if (currentLink === '/p2p/post-ad') {
      setYoutubeLink('https://youtu.be/MSMNZ4YkiIA');
    } else if (currentLink === '/p2p/my-ads') {
      setYoutubeLink('https://youtu.be/MSMNZ4YkiIA');
    } else if (currentLink === '/futures') {
      setYoutubeLink('https://youtu.be/U_on0Mc9Wxs');
    } else if (currentLink === '/options') {
      setYoutubeLink('https://youtu.be/U_on0Mc9Wxs');
    } else if (currentLink === '/recurring-payments') {
      setYoutubeLink('https://youtu.be/5Ha7J-Ti1rg');
    } else if (currentLink === '/web3-wallet') {
      setYoutubeLink('https://youtu.be/PJKggY7w2yc');
    } else if (currentLink === '/earn-interest') {
      setYoutubeLink('https://youtu.be/Z8g8tKX8_z8');
    } else if (currentLink === '/portfolio-invest') {
      setYoutubeLink('https://youtu.be/XutCxLFJ7Bs');
    } else if (currentLink === '/crypto-loans') {
      setYoutubeLink('https://youtu.be/3ckLJtYGUhA');
    } else if (currentLink === '/copy-trading') {
      setYoutubeLink('https://www.youtube.com/playlist?list=PLjtm4vdHCgKa9Aw7e-DtT7x6U-bXBw0GT');
    } else if (currentLink === '/add-apiKey') {
      setYoutubeLink('https://www.youtube.com/playlist?list=PLjtm4vdHCgKa9Aw7e-DtT7x6U-bXBw0GT');
    } else if (currentLink === '/my-bots') {
      setYoutubeLink('https://www.youtube.com/playlist?list=PLjtm4vdHCgKa9Aw7e-DtT7x6U-bXBw0GT');
    } else if (currentLink === '/my-bots/create-new-bot') {
      setYoutubeLink('https://www.youtube.com/playlist?list=PLjtm4vdHCgKa9Aw7e-DtT7x6U-bXBw0GT');
    } else if (currentLink === '/marketplace') {
      setYoutubeLink('https://www.youtube.com/playlist?list=PLjtm4vdHCgKa9Aw7e-DtT7x6U-bXBw0GT');
    } else if (currentLink === '/my-followers') {
      setYoutubeLink('https://www.youtube.com/playlist?list=PLjtm4vdHCgKa9Aw7e-DtT7x6U-bXBw0GT');
    } else if (currentLink === '/my-payouts') {
      setYoutubeLink('https://www.youtube.com/playlist?list=PLjtm4vdHCgKa9Aw7e-DtT7x6U-bXBw0GT');
    } else if (currentLink === '/manage-copytrading') {
      setYoutubeLink('https://www.youtube.com/playlist?list=PLjtm4vdHCgKa9Aw7e-DtT7x6U-bXBw0GT');
    } else if (currentLink === '/copy-trading-history') {
      setYoutubeLink('https://www.youtube.com/playlist?list=PLjtm4vdHCgKa9Aw7e-DtT7x6U-bXBw0GT');
    } else {
      setIsLinkAvailable(false);
    }
    */
  };

  const getBrokerExchangeFeatures = async () => {
    const brokerId = localStorage.getItem("BROKERID");
    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getBrokerExchangeFeatures/${brokerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      console.log("response setting", response);
      setSettingFeature(response?.data?.features);
    } catch (error) {
      console.error("Error fetching API keys", error);
    }
  };

  const toggleCard = () => {
    setShowText(!showText);
  };

  const openyoutubeLink = () => {
    window.open(youtubeLink, "_blank");
  };

  console.log("youtubeLink", youtubeLink);

  return (
    <div className="drawer-popup">
      {/* isLinkAvailable */}

      {settingFeature?.enableChatGpt === 1 && (
        <Tooltip
          title={`Ask your ${brokerBasicInfo?.exchange} AI buddy Whizzo anything !`}
          arrow
        >
          <span className="drawer-handle tour14" onClick={handleOpenChatPopUp}>
            <ElectricBoltIcon sx={{ color: btncolor }} />
          </span>
        </Tooltip>
      )}

      {settingFeature?.enableChatWithTrader === 1 && (
        <Tooltip title="Chat" arrow>
          <span className="drawer-handle-chat">
            <a href="/chat">
              <i className="drawer-logo">
                <img
                  src={brokarChatLogo}
                  style={{ margin: "-5px 0px 0px 0px", width: 20, height: 19 }}
                  alt="broker chat"
                />
              </i>
            </a>
          </span>
        </Tooltip>
      )}

      {pageName === "spot" && (
        <span className="drawer-handle-tour tour31" onClick={callParent}>
          <TourIcon></TourIcon>
        </span>
      )}

      {isChatPopUpOpen && (
        <div
          className={`chat-popup ${themeColor === "dark" ? "" : "sideLite"}`}
          id="myForm"
        >
          <form className="form-container" onSubmit={handleSendMessage}>
            <div className="row">
              <div className="col-md-10">
                <h3>Chat</h3>
                <small>powered by Whizzo</small>
              </div>
              <div className="col-md-2">
                <CloseIcon
                  onClick={handleOpenChatPopUp}
                  sx={{ cursor: "pointer" }}
                />
                {/* <span
                  onClick={handleOpenChatPopUp}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </span> */}
              </div>
            </div>

            <div className="chat-container" ref={containerRef}>
              <ul className="no-bullets">
                {chatList.map((chat, index) => (
                  <li key={index}>
                    <div
                      className={
                        !chat.messageSendByUser ? "message-bot" : "message-user"
                      }
                    >
                      <div
                        ref={(el) => (messageRefs.current[index] = el)}
                        className={`row ${
                          !chat.messageSendByUser
                            ? "message-bot-row"
                            : "message-user-row"
                        }`}
                      >
                        <div className="col-md-2">
                          {!chat.messageSendByUser ? (
                            <ElectricBoltIcon sx={{ color: btncolor }} />
                          ) : (
                            <img
                              src={isValid ? userProfileImage : defaultuser}
                              className="rounded-circle mr-2"
                              style={{ width: 20, height: 20 }}
                              alt="User"
                            />
                          )}
                        </div>
                        <div className="col-md-8">
                          <p
                            style={{
                              marginRight: "-40px",
                              wordWrap: "break-word",
                              color:
                                chat.messageSendByUser && themeColor !== "dark"
                                  ? "#000"
                                  : "inherit",
                            }}
                          >
                            {chat.message}
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <label htmlFor="msg">
              <b>Message</b>
              {isMessageSending && (
                <img
                  src={chatLoader}
                  style={{ width: 200, position: "absolute", top: 150 }}
                  alt="Loading..."
                />
              )}
            </label>
            <input
              ref={inputRef}
              type="text"
              className={`form-control`}
              value={chatText}
              onChange={(e) => setChatText(e.target.value)}
              placeholder="Enter text here..."
            />
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <ContainedButton
                type="submit"
                //   className="btn btn-success"
                style={{
                  padding: "5px 17px",
                  opacity: "0.8",
                  height: "50px",
                  color: "#fff",
                }}
                disabled={isMessageSending}
              >
                Send
              </ContainedButton>
              <ContainedButton
                type="button"
                //   className="btn btn-danger"
                style={{
                  padding: "5px 17px",
                  opacity: "0.8",
                  height: "50px",
                  color: "#fff",
                }}
                onClick={handleOpenChatPopUp}
              >
                Close
              </ContainedButton>
            </Box>
          </form>
        </div>
      )}
      {/* isLinkAvailable */}
      {isLinkAvailable && (
        <Link>
          <Tooltip>
            <div className="youtubePlace">
              <div className="youtube-icon" onClick={toggleCard}>
                <div
                  className="layers"
                  title="Youtube Link"
                  style={{ width: showText ? "207px" : "35px" }}
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png"
                    alt="YouTube"
                  />
                  <span
                    className="youtube-text"
                    style={{ display: showText ? "inline" : "none" }}
                    onClick={openyoutubeLink}
                  >
                    <a
                      className="youtubeAnchor"
                      href={youtubeLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i>How does this work?</i>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </Tooltip>
        </Link>
      )}
    </div>
  );
};

export default ChatPopUp;
